var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"field is-horizontal"},[_c('div',{staticClass:"field-label is-normal"},[_c('label',{staticClass:"label"},[_c('marker-helper',{attrs:{"name":_vm.helper}}),_vm._v("\n      "+_vm._s(_vm._f("uppercaseFirstLetter")(_vm.label))+"\n    ")],1)]),_vm._v(" "),_c('div',{staticClass:"field-body"},[_c('div',{staticClass:"field",class:{
        'is-grouped is-grouped-multiline': _vm.isGrouped,
        'is-expanded': _vm.isExpanded,
        'is-narrow': _vm.isNarrow,
      }},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }